import { BehaviorSubject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Login } from '../models/classes/login';
import { environment } from 'src/environments/environment';
import { SystemInfoModel } from '../models/classes/system-info';
import { LoginResponseModel } from '../models/classes/loginresponse';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  ip = environment.ipServer;
  result: BehaviorSubject<number>;
  validated: any;

  httpOptions: { headers; observe } = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    observe: 'response',
  };

  constructor(private http: HttpClient) {}

  validateCredential(login: Login): Observable<object> {
    let userUrl = `${this.ip}/api/userlogin/login/`;
    const url = `${userUrl}`;
    return this.http.post(url, login);
  }

  getToken() {
    return localStorage.getItem('jwt');
  }
  get res(): Observable<number> {
    return this.result.asObservable();
  }
  refresh(refreshmodel: LoginResponseModel) {
    let userUrl = `${this.ip}/api/userlogin/refresh/`;
    const url = `${userUrl}`;
    return this.http.post(url, refreshmodel);
  }
  getConnectedDetails() {
    const url = `${this.ip}/api/systeminfo/getschemainfo`;
    return this.http.get<SystemInfoModel>(url);
  }
}
